//#region src/locales/en/common.json
var e = {
	actions: {
		delete: "Delete",
		rename: "Rename"
	},
	copied: "Copied!",
	copy: "Copy",
	disclaimer: "AI can make mistakes. Please verify important info",
	empty_state: { no_conversations_yet: "No conversations yet" },
	errors: {
		could_not_get_response: "We couldn't get a response.<br />Please try again.",
		please_try_again: "Please try again",
		something_went_wrong: "Something went wrong",
		try_again_later: "Error please try again later"
	},
	helpful: "Helpful",
	history: {
		last_7_days: "Last 7 days",
		older: "Older",
		title: "Chat history",
		today: "Today",
		yesterday: "Yesterday"
	},
	limit_alert: {
		description_suffix: "To continue, wait until {{resetDate}} for your credits to reset",
		title: "You've used all your AI credits"
	},
	not_helpful: "Not helpful",
	prompt_placeholder: "Ask AI Chat...",
	thinking: "AI Chat is thinking",
	title: "AI Chat"
}, t = { ai_chat: e };
//#endregion
export { e as ai_chat, t as default };
